import baseApi from 'store/slices/api/baseApi'

const mediasApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        updateMedia: builder.mutation({
            query: ({mediaId, body}) => ({
                url: `medias/user/${mediaId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Dance'],
        }),
        deleteMedia: builder.mutation({
            query: ({mediaId, body}) => ({
                url: `medias/user/${mediaId}`,
                method: 'DELETE',
                body,
            }),
            invalidatesTags: ['Dance'],
        }),
    }),
    overrideExisting: false,
})

export const {useDeleteMediaMutation, useUpdateMediaMutation} = mediasApi
export default mediasApi
